import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Router from "./router";
function App() {
  return (
    <>
    <ToastContainer />
      <Router />
    </>
  );
}

export default App;
